import $ from 'jquery'
import {
    SET_FULL_INFO,
    MERGE_INFO,
    SET_CURRENT
} from './mutation-types'

export default {
    [SET_FULL_INFO](state, payload) {
        let id = payload.id
        state.data['I'+id] = payload
    },
    
    [MERGE_INFO](state, payload) {
        let id = payload.id
        let paths = payload.paths.split(',').map((v) => {
            return $.trim(v)
        })
        let merge = []
        payload = $.extend(true, {}, payload.payload)
        
        $.each(paths, (i, v) => {
            if(!/\./.test(v)) {
                state.data['I'+id][v] = $.isArray(payload[v]) ?payload[v] :$.extend(true, {}, payload[v])
                delete payload[v]
            }
            else {
                state.data['I'+id] = window.Vue.peer.misc.deleteKey(state.data['I'+id], v)
                merge.push(v)
            }
        })
        
        if(merge.length)
            state.data['I'+id] = $.extend(true, {}, state.data['I'+id], payload)
    },
    
    [SET_CURRENT](state, payload) {
        let data = []
        
        for(let i=0; i<3; i++) {
            if(payload.position-1 === i) {
                data[i] = payload.data
                state.current = data
                return
            }
            else if(state.current[i])
                data[i] = state.current[i]
            else
                return
        }
    }
}
